<template>
   <div class="row">
       <div class="col-12">
         <div class="card-header-actions">
           <div class="col-12 justify-content-md-end mt-md-0 mt-2 card-header-btns-box">
             <button class="all-btn add-btn m-0" v-if="hasPermission('SETTINGS_BUILDING_OTHER_CONTRACT_AMOUNT_ADD')" @click="showRentalRatesForLegalModal">
               {{$t("action.add")}}
             </button>
           </div>
         </div>

       </div>
       <div class="col-12">
           <div class="table-wrapper">
             <table class="table table-hover">
                 <thead>
                     <tr>
                         <th>#</th>
                         <th class="text-center">Обеъкт тури</th>
                         <th class="text-center">1 гекторга</th>
                         <th class="text-center">1 гектордан ошганда</th>
                     </tr>
                 </thead>
                 <tbody v-if="!loading && results && results.data">
                 <tr v-for="result in results.data" :key="result.id">
                     <td>{{result.id}}</td>
                     <td class="text-center">
                         <span v-if="result.data.category === 'GREEN_HOUSE'">Иссиқхона</span>
                         <span v-if="result.data.category === 'LAKE'">Кўл</span>
                         <span v-if="result.data.category === 'GARDEN'">Боғлар</span>
                     </td>
                     <td class="text-center">
                         <div>( {{result.data.minArea | currency('', 2, { thousandsSeparator: ' ' })}} м2 - дан {{result.data.maxArea | currency('', 2, { thousandsSeparator: ' ' })}} м2 гача )</div>
                         <div class="font-weight-bold">{{result.data.minContractAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўм</div>
                     </td>
                     <td class="text-center">
                         <div>( {{result.data.perArea | currency('', 2, { thousandsSeparator: ' ' })}} м2 учун ) </div>
                         <div class="font-weight-bold">{{result.data.perAreaAmount | currency('', 2, { thousandsSeparator: ' ' })}} сўмдан</div>
                     </td>
                 </tr>
                 </tbody>
             </table>
           </div>
           <div class="text-center">
               <div class="loader mt-5 mb-5" v-if="loading"></div>
               <span class="no-data mt-5 mb-5" v-if="!loading && results && results.data && results.data.length===0">{{$t("messages.list.empty")}}</span>
           </div>
           <div class="row" v-if="!loading && results && results.total && results.total > 1 ">
               <div class="col-12 pt-3 pb-3">
                   <b-pagination :total-rows="results.total" v-model="filter.page.page" :per-page="filter.page.size" @change="onPageChange">
                   </b-pagination>
               </div>
           </div>
       </div>
       <LCElementContractAmountEditModal @change="initList"></LCElementContractAmountEditModal>
   </div>
</template>

<script>
    import LCElementContractAmountEditModal from "./LCElementContractAmountEditModal";
    import initFilterModel from '@/shared/filter';
    import bPagination from 'bootstrap-vue/es/components/pagination/pagination';

    export default {
        name: "LightConstructiveElementContractAmountList",
        components: {
            LCElementContractAmountEditModal,
            'b-pagination': bPagination
        },
        data() {
            return {
                loading: false,
                filter: initFilterModel(),
                results: null
            }
        },
        methods: {
            initList() {
                this.loading = true;
                const vm = this;
                this.$http.post('dictionary/list/REAL_ESTATE_OTHER_CONTRACT_AMOUNT', this.filter)
                    .then(res => {
                        this.results = res.data;
                        vm.loading = false;
                    }, err => {
                        console.log(err);
                        vm.loading = false;
                    });
            },
            showRentalRatesForLegalModal() {
                this.$eventBus.$emit('showLCElementContractAmountModal')
            },
            onPageChange(page) {
                this.filter.page.page = page;
                this.initList();
            }
        },
        created() {
            this.initList()
        }
    }
</script>

<style scoped>

</style>